import React, { createContext, useEffect, useState } from "react";
import { returNombreRuta } from "../utils/funciones";
import { useLocation } from "react-router-dom";
import { getUno } from "../api/apis";

export const DataContext = createContext();
export const DataContextContractual = createContext();
export const ContextApi = ({ children }) => {
  const [selectModulo, setSelectModulo] = useState(undefined);
  const [reingresa, setReingresa] = useState(false);
  const [listaGuardado, setLista] = useState([]);
  const [visibleNotificaciones, setVisibleNotificaciones] = useState([]);
  const [nombreMenu, setNombreMenuu] = useState('');
  const [page, setPage] = useState(0);
  const [objTemporal, setObjTemporal] = useState([]);
  const [uno, setUno] = useState(undefined);
  const [dataObj, setDataObj] = useState(undefined);
  const [notificaciones, setNotificaciones] = useState([]);




  // const location = useLocation();
  // useEffect(() => {
  //   setNombreMenuu(returNombreRuta(location.pathname));
  // }, [location]);

  function setListaGuardado(item) { setLista([...listaGuardado, item]); }

  function setearPagina(item) { setPage(item); }

  const data_ = {
    visibleNotificaciones, setVisibleNotificaciones, objTemporal, setObjTemporal,
    reingresa, cambioReingresa: setReingresa, listaGuardado, setListaGuardado,
    page, setearPagina, nombreMenu, notificaciones, setNotificaciones,
    selectModulo, setSelectModulo, dataObj, setDataObj, uno, setUno, setNombreMenuu
  }

  return (<DataContext.Provider value={data_}>{children}</DataContext.Provider>)
}

export const ContextContractualApi = ({ children }) => {
  const [dataListado, setDataListado] = useState({ headers: [], id_columnas: [], arrData: [] });
  const [diasAnticipo, setDiasAnticipo] = useState(0);
  const [tipoSolicitud, setTipoSolicitud] = useState('');
  const [visibleAprobador, setVisibleAprobador] = useState(false);
  const [visibleModalForm, setVisibleModalForm] = useState(false);
  const [dataModalForm, setDataModalForm] = useState({
    titulo: "Cambio de instalación",
    component: (
      <div>esta es la prueba</div>
    ),
  });

  const ObtenerDiasAnticipacion = async () => {
    // Lógica para obtener los días de anticipación
    const resp = await getUno('configuracion', null, null);
    if (resp.data.status !== "success") {
      setDiasAnticipo(0)
    }
    setDiasAnticipo(resp.data.data.dias_anticipacion);
  }


  useEffect(() => {
    ObtenerDiasAnticipacion()
  }, []);

  const data = {
    dataListado, setDataListado, diasAnticipo, setDiasAnticipo, tipoSolicitud, setTipoSolicitud,
    visibleAprobador, setVisibleAprobador, visibleModalForm, setVisibleModalForm, dataModalForm, setDataModalForm
  }

  return (
    <DataContextContractual.Provider value={data}>
      {children}
    </DataContextContractual.Provider>
  )
}